module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-fr-FR.d951d720.jpg";